import React from 'react';
import styled from 'styled-components';

const FooterWrapper = styled.footer`
    width: 100%;
    padding: 1em;
    background-color: var(--primary-color);
    color: var(--secondary-color);
    text-align: center;
    border-top: 1px solid var(--primary-color);
    height: 3em;
    position: absolute;
    bottom: 0;
    font-size: 0.8em;
`;


const Footer = () => {
    return(
        <FooterWrapper>© 2024 Troisprime. All rights reserved</FooterWrapper>
    )
}

export default Footer;